<template>
  <div class="my-wait-receive">
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <el-radio-group
          v-model="value"
          @change="onStatusChange"
        >
          <el-radio-button label="wait">{{ $t('asm_my_wait_receive.dai_jie_dan') }}</el-radio-button>
          <el-radio-button label="ing">{{ $t('asm_my_wait_receive.chu_li_zhong') }}</el-radio-button>
          <el-radio-button label="finish">{{ $t('asm_my_wait_receive.yi_wan_cheng') }}</el-radio-button>
          <el-radio-button label="unresolved">{{ $t('asm_my_wait_receive.wei_jie_jue') }}</el-radio-button>
        </el-radio-group>
        <!-- 导出excel -->
        <el-form-item
          style="float: right; margin-right: 0"
          v-if="funcView.my_work_order_export"
        >
          <el-button
            class="table-set"
            style="vertical-align: top"
            @click="exportOrder(tableColumn, false, 'wait')"
          ><i class="icon icon-daochu"></i></el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item
          style="float: right;"
          :class="{ 'mr-0': !funcView.my_work_order_export }"
        >
          <custom-column
            :code="tableCode"
            v-model="tableColumn"
          ></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.keyword"
            @fetch="onPageChange({ page: 1 })"
            :placeholder="$t('asm_my_wait_receive.gdbhjsh')"
          ></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      ref="container"
      @search="onPageChange({ page: 1 })"
      @clear="clearFilter('keyword')"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
        <el-form-item :label="$t('asm_my_wait_receive.shang_bao_shi_jian')">
          <custom-date-picker
            v-model="formSearch.gmtCreate"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('asm_my_wait_receive.chan_pin_xing_hao')">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :props="{ label: 'productCode', value: 'productCode' }"
            :placeholder="$t('Common.com_please_select')"
            width="100%"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('asm_my_wait_receive.zu_lin_fang')">
          <el-input v-model="formSearch.customerName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('asm_my_wait_receive.xiang_mu')">
          <el-input v-model="formSearch.locationName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('asm_my_wait_receive.shou_hou_gong_si')">
          <el-input v-model="formSearch.afterServiceName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('asm_my_wait_receive.dai_li_gong_si')">
          <el-input v-model="formSearch.agentCoName"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        ref="customTb1"
        height="100%"
        :data="tableList"
        :column="tableColumn"
        :index="true"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['workOrderCode','bodyNum', 'workOrderTimeHhmm']"
      >
        <template v-slot:workOrderCode="scope">
          <span
            class="cell-link"
            v-if="[10,20,50].includes(scope.row.workOrderType) && funcView.my_work_order_detail"
            @click="toOrderDetail(scope.row, {isPersonal: true})"
          >{{scope.row.workOrderCode}}</span>
          <span v-else>{{scope.row.workOrderCode}}</span>
        </template>
        <template v-slot:bodyNum="scope">
          <span
            class="cell-link"
            v-if="funcView.my_work_device_detail"
            @click="toDeviceDetail(scope.row)"
          >{{scope.row.bodyNum}}</span>
          <span v-else>{{scope.row.bodyNum}}</span>
        </template>
        <template v-slot:workOrderTimeHhmm="scope">
          {{getOrderPayTime(scope.row)}}
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
  </div>
</template>

<script>
/** 我的待接单 */
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import tableFilterValueGetParamMixins from '@/mixins/table_filterValue_getParam_mixins.js';
import orderMixin from './orderMixin';

export default {
  name: '',
  mixins: [orderMixin, resetFormSearchMixins, tableFilterValueGetParamMixins],
  components: {},
  props: {
    value: [String, Array, Number],
  },
  data() {
    return {
      tableCode: 'all_wait_receive',
      formSearch: {
        keyword: '',
        pageSize: 50,
        pageNum: 1,
        gmtCreate: [],
        productCode: '',
        customerName: '',
        locationName: '',
        afterServiceName: '',
        technicianName: '',
        agentCoName: '',
      },
      tableList: [],
      totalRows: null,
    };
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {
    onStatusChange(value) {
      this.$emit('input', value);
    },
    getTableList() {
      this.$getJSON(apis.WorkOrderPageMyselfWait, this.formSearch, true).then((res) => {
        this.tableList = res.data.records;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
  created() { },
  mounted() {
    this.resetForm = JSON.stringify(this.form);
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableColumn();
    this.getTableList();
    this.getFuncView();
  },
};
</script>

<style lang="scss" scoped>
.my-wait-receive {
  display: flex;
  flex-direction: column;
  height: 100%;

  .case-order-code {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
